export * from "./TabsTemplate";
export { default as TabsTemplate } from "./TabsTemplate";
